// Components==============
import Button from 'components/UI/Button/Button';
import Checkbox from 'components/UI/Checkbox/Checkbox';
import Modal from 'components/UI/Modal/Modal';
import { useRootModal } from 'hooks/useRootModal';
import { useTranslate } from 'hooks/useTranslate';
import React, { useState } from 'react';
import './ConfirmModal.module.scss';
// =========================

export default function ConfirmModal({
  handleSave,
}: {
  handleSave: (andLook?: boolean | undefined) => void;
}) {
  const translate = useTranslate();

  const [checked, setChecked] = useState(false);

  const { closeModal } = useRootModal();

  return (
    <Modal size="medium">
      <div styleName="wrapper">
        <img src="/images/publication-popup-image.svg" alt="publication" />
        <h2>{translate('course.update-course-popup.title')}</h2>
        <p>
          <strong>{translate('course.update-course-popup.sub-title')}</strong>
          {translate('course.update-course-popup.text01')}
          <br />
          {translate('course.update-course-popup.text02')}
          <br />
          {translate('course.update-course-popup.text03')}
        </p>
        <Checkbox isChecked={checked} setIsChecked={setChecked}>
          {translate('course.update-course-popup.checkboxlabel')}
        </Checkbox>
        <div styleName="button-wrapper">
          <Button color="grey" onClick={closeModal}>
            {translate('general.terms.cancel')}
          </Button>
          <Button
            inactive={!checked}
            onClick={() => {
              handleSave(true);
              closeModal();
            }}
          >
            {translate('general.terms.update')}
          </Button>
        </div>
      </div>
    </Modal>
  );
}
